import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TermsOfUse = () => {
  const [customContent, setCustomContent] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/settings`);
        if (res.data.terms_of_use_content) {
          setCustomContent(res.data.terms_of_use_content);
        }
      } catch (e) {
        console.error('Failed to fetch settings:', e);
      }
    };
    fetchSettings();
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      
      <div className="pt-44 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-[#0a0203] mb-8">Terms of Use</h1>
          
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 prose prose-lg max-w-none">
            <p className="text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
            
            {customContent ? (
              <div className="text-gray-600" dangerouslySetInnerHTML={{ __html: customContent }} />
            ) : (
              <>
            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600 mb-6">
              By accessing and using the LyphLine Freeze Dryers website (the "Site"), you accept and agree to be bound by these 
              Terms of Use. These terms apply to all users of the Site in <strong>Canada</strong> and the <strong>United States of America</strong>. 
              If you do not agree to these terms, please do not use our Site.
            </p>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">2. Eligibility</h2>
            <p className="text-gray-600 mb-6">
              Our products and services are available to individuals who are at least 18 years of age and reside in 
              Canada or the United States. By using this Site, you represent and warrant that you meet these eligibility requirements.
            </p>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">3. Use of the Site</h2>
            <p className="text-gray-600 mb-4">You agree to use the Site only for lawful purposes and in accordance with these Terms and all applicable laws of Canada and the United States. You agree not to:</p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Use the Site in any way that violates any applicable federal, provincial, state, or local law or regulation</li>
              <li>Engage in any conduct that restricts or inhibits anyone's use of the Site</li>
              <li>Attempt to gain unauthorized access to any part of the Site</li>
              <li>Use any automated means to access the Site for any purpose</li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">4. Products and Pricing</h2>
            <p className="text-gray-600 mb-6">
              All products displayed on the Site are subject to availability and may vary by region. We reserve the right to limit quantities 
              and to discontinue any product at any time. Prices are subject to change without notice. Prices are displayed in 
              <strong> Canadian Dollars (CAD)</strong> for Canadian customers and may be converted to <strong>US Dollars (USD)</strong> for 
              American customers using current exchange rates plus applicable adjustments. Final pricing will be confirmed at checkout.
            </p>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">5. Orders and Payment</h2>
            <p className="text-gray-600 mb-6">
              By placing an order, you represent that you are at least 18 years of age, reside in Canada or the United States, 
              and that the information you provide is accurate and complete. We accept payment in both CAD and USD. 
              We reserve the right to refuse or cancel any order for any reason. All orders are subject to product availability 
              and confirmation of the order price.
            </p>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">6. Shipping and Delivery</h2>
            <p className="text-gray-600 mb-4">
              We ship to addresses in Canada and the United States. Shipping times and costs vary based on destination and shipping method selected.
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li><strong>Canada:</strong> Domestic shipping within Canada typically takes 5-10 business days</li>
              <li><strong>United States:</strong> International shipping to the US typically takes 7-14 business days</li>
              <li>Cross-border shipments may be subject to customs duties and taxes, which are the responsibility of the buyer</li>
              <li>We are not responsible for delays caused by shipping carriers, customs clearance, or events beyond our control</li>
            </ul>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">7. Returns and Refunds</h2>
            <p className="text-gray-600 mb-6">
              Our return policy applies to customers in both Canada and the United States. Defective products may be 
              returned within 30 days of delivery for a full refund or replacement. Return shipping costs may vary 
              depending on your location. Please refer to our return policy or contact us for specific details.
            </p>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">8. Intellectual Property</h2>
            <p className="text-gray-600 mb-6">
              All content on the Site, including text, graphics, logos, images, and software, is the property of 
              LyphLine Freeze Dryers or its content suppliers and is protected by copyright and other intellectual property laws 
              of Canada, the United States, and international treaties.
            </p>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">9. Limitation of Liability</h2>
            <p className="text-gray-600 mb-6">
              To the fullest extent permitted by applicable law in Canada and the United States, LyphLine Freeze Dryers shall not be liable for any 
              indirect, incidental, special, consequential, or punitive damages arising out of your use of the Site 
              or products purchased through the Site.
            </p>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">10. Governing Law and Jurisdiction</h2>
            <p className="text-gray-600 mb-4">
              These Terms shall be governed by and construed as follows:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li><strong>For Canadian Residents:</strong> These Terms are governed by the laws of the Province of Alberta and the federal laws of Canada applicable therein</li>
              <li><strong>For US Residents:</strong> These Terms are governed by the laws of the State of Delaware and applicable federal laws of the United States</li>
            </ul>
            <p className="text-gray-600 mb-6">
              Any disputes shall be resolved in the appropriate courts of the governing jurisdiction based on your country of residence.
            </p>

            <h2 className="text-2xl font-semibold text-[#0a0203] mt-8 mb-4">11. Contact Us</h2>
            <p className="text-gray-600">
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="text-gray-600 mt-2">
              <strong>Email:</strong> <a href="mailto:service@lyphlinefreezedry.com" className="text-[#003456] hover:underline">service@lyphlinefreezedry.com</a><br />
              <strong>Canada:</strong> Chinook Manufacturing Inc., Canada<br />
              <strong>United States:</strong> LyphLine Freeze Dryers US Operations
            </p>
              </>
            )}
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default TermsOfUse;
